import { inject } from "@angular/core";
import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { RedirectionService } from "../services/redirection.service";

export const httpRequestInterceptor: HttpInterceptorFn = (req, next) => {
  const redirectionService = inject(RedirectionService);

  const requestWithCredentials = req.clone({
    withCredentials: true
  });

  return next(requestWithCredentials).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        sessionStorage.clear();
        localStorage.removeItem("user_preferences");

        return redirectionService.getRedirectionUrl().pipe(
          switchMap((url: string) => {
            window.location.href = url;
            return throwError(() => err);
          }),
          catchError((innerErr: unknown) => {
            return throwError(() => innerErr);
          })
        );
      }
      return throwError(() => err);
    })
  );
};
